import { render, staticRenderFns } from "./wechatMenu.vue?vue&type=template&id=780dd55e&scoped=true"
import script from "./wechatMenu.vue?vue&type=script&lang=js"
export * from "./wechatMenu.vue?vue&type=script&lang=js"
import style0 from "./wechatMenu.vue?vue&type=style&index=0&id=780dd55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780dd55e",
  null
  
)

export default component.exports